// extracted by mini-css-extract-plugin
module.exports = {"categoryListContainer":"_1laFb","title":"_2Qq4e"};